// Impact Quarterly issue page: the issue's articles are rendered once (impactQuarterlyArticles) and paged on the client.
const impactQuarterlyApp = Vue.createApp({
    data() {
        return {
            articles: typeof impactQuarterlyArticles !== 'undefined' && Array.isArray(impactQuarterlyArticles) ? impactQuarterlyArticles : [],
            articlesPerPage: 10,
            currentPage: 1
        };
    },

    methods: {
        ...PublicationCardMethods,

        goToPage(pageNumber) {
            if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > this.totalPages || pageNumber === this.currentPage) return;

            this.currentPage = pageNumber;
            scrollOnPagination('impactQuarterlyArticles');
        }
    },

    computed: {
        totalPages() {
            return Math.ceil(this.articles.length / this.articlesPerPage);
        },

        articlePages() {
            return pagination(this.currentPage, this.totalPages);
        },

        displayedArticles() {
            const start = (this.currentPage - 1) * this.articlesPerPage;
            return this.articles.slice(start, start + this.articlesPerPage);
        }
    }
});

impactQuarterlyApp.mount('#impactQuarterlyArticles');
